import { render, staticRenderFns } from "./ReviewsFilter.vue?vue&type=template&id=1589ff1c&scoped=true"
import script from "./ReviewsFilter.vue?vue&type=script&lang=js"
export * from "./ReviewsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1589ff1c",
  null
  
)

export default component.exports